import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";
import { format } from "date-fns";
import "react-day-picker/dist/style.css";
import classNames from "classnames";

//CUSTOM COMPONENT
import CardReporting from "../../aGlobalDesign/Reporting/CardReporting";
import Loader from "../../aGlobalDesign/Loader/Loader";

// Disable date after today on date picker
const currentDate = new Date();
const tomorrow = new Date(currentDate);
tomorrow.setDate(currentDate.getDate() + 1);
const dateInOneYear = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate());
const disabledDays = [
    { from: tomorrow, to: dateInOneYear }
];

class Dashboard extends React.Component {

    constructor() {
        super();
        const end = new Date();
        const start = new Date();
        start.setUTCDate(start.getUTCDate() - 7);

        this.state = {
           
            dateSelected: {
                // 7 days before today
                "Start date": start.toISOString().slice(0, 19).replace("T", " "),
                // Today
                "End date": end.toISOString().slice(0, 19).replace("T", " "),
            },     
            results: null,
            reload: 0
        };
    }
    componentDidMount() {
        this.props.changeAppBarTitle("dashboardFullView");
        this.props.ChangeCurrentMenuName("dashboardFullView");
        this.GetNewReporting(
            this.props.dateSelected["Start date"],
            this.props.dateSelected["End date"],
            this.props.zoneSelected ? this.props.zoneSelected.id : null,
            this.props.callcenterSelected ? this.props.callcenterSelected.id : null
        );
    }
    componentDidUpdate(prevProps) {
        const reload = this.props.reload;
        if (reload && this.props.reload && this.state.reload !== reload) {
            this.setState({ reload: reload });
            this.GetNewReporting(
                this.props.dateSelected["Start date"],
                this.props.dateSelected["End date"],
                this.props.zoneSelected ? this.props.zoneSelected.id : null,
                this.props.callcenterSelected ? this.props.callcenterSelected.id : null
            );
        }
    }
    GetNewReporting(dateSTart, dateEnd, zoneId, callCenterId) {
        this.setState({ results: null });
        this.props.onRequestStatistics(callCenterId, zoneId, dateSTart, dateEnd, (data) => {
            console.log("reporting successs", { dateStart: dateSTart, dateEnd: dateEnd, data: data });

            this.setState({ results: data });
        });
    }

    getNotesArray(arrayReview, totalReview) {
        const result = [];
        let notedCalls = 0;
        const hn = { note: "5", quantity: 0 };
        for (let i = 5; i > 0; i--) {
            const review = arrayReview.find(obj => Number(obj.name) === i);
            if (!review) {
                result.push({ note: i.toString(), quantity: 0 });
            }
            else {
                notedCalls += review.count;
                if (review.count > hn.quantity) {
                    hn.note = review.name;
                    hn.quantity = review.count;
                }
                result.push({ note: review.name, quantity: review.count });
            }
        }
        if (totalReview !== null) {
            const noNote = { note: null, quantity: totalReview ? totalReview - notedCalls : 0 };
            if (noNote.quantity > hn.quantity) {noNote.isHighest = true;}
            else {
                result.find(obj => obj.note === hn.note).isHighest = true;
            }
            result.push(noNote);
        }
        return result;
    }

    addDays(date, days) {
        date.setDate(date.getDate() + days);
        return date;
    }

    getDatesArray(arrayDates, addsubdatas) {
        const result = [];
        const subsections = [];
        const datestart = new Date(this.props.dateSelected["Start date"]);
        const dateend = this.addDays(new Date(this.props.dateSelected["End date"]), 1);
        let curDate = datestart;
        const oneDate = arrayDates.length === 0 || format(new Date(arrayDates[0].name), "yyyy-MM-dd") === format(new Date(arrayDates[arrayDates.length - 1].name), "yyyy-MM-dd");
        arrayDates.forEach(d => {
            if (!subsections.includes(d.subtitle)) {
                subsections.push(d.subtitle);
            }
        });

        while (format(curDate, "yyyy-MM-dd") !== format(dateend, "yyyy-MM-dd")) {
            const obj = {
                name: format(curDate, "yyyy-MM-dd"),
                short: oneDate ? format(curDate, "dd.MM") : format(curDate, "dd"),
                subdatas: addsubdatas ? {} : null
            };
            subsections.forEach(s => {
                const data = arrayDates.find(dt => dt.subtitle === s && dt.name === format(curDate, "yyyy-MM-dd"));
                if (data !== undefined) {
                    obj[s] = data.count;
                    if (addsubdatas) {obj.subdatas[s] = addsubdatas(data.subtitle2);}
                }
                else {
                    obj[s] = 0;
                    if (addsubdatas) {obj.subdatas[s] = "";}
                }
            });
            result.push(obj);
            curDate = this.addDays(curDate, 1);
        }
        const obj = {
            results: result,
            subsections: subsections
        };
        return obj;
    }
    getCallByDayOfWeekArray(arrayDates) {
        const subsection = "Appels";
        const result = [];
        const subsections = [subsection];

        const week = [{ day: strings.monday, value: 2 }, { day: strings.tuesday, value: 3 }, { day: strings.wednesday, value: 4 }, { day: strings.thursday, value: 5 }, { day: strings.friday, value: 6 }, { day: strings.saturday, value: 7 }, { day: strings.sunday, value: 1 }];
        week.forEach(dow => {
            const dayData = arrayDates.find(d => d.name === dow.value.toString());
            const newr = {
                name: dow.day,
                short: dow.day
            };
            newr[subsection] = dayData ? dayData.count : 0;
            result.push(newr);
        });

        const obj = {
            results: result,
            subsections: subsections
        };
        return obj;
    }
    getCallByHourOfDayArray(darrayDates) {
        const subsection = "Appels";
        const result = [];
        const subsections = [subsection];

        const arrayDates = [];
        darrayDates.forEach(hour => {
            const date = new Date();
            if (hour.subtitle.toString() === "120") {
                //on est à l'heure d'été
                date.setMonth(7);
            }
            else {
                date.setMonth(0);
            }
            date.setUTCHours(Number(hour.name));
            const newName = date.getHours().toString();
            const curHour = arrayDates.find(h => h.name === newName);
            if (curHour) {
                curHour.count += hour.count;
            }
            else {
                arrayDates.push({ ...hour, name: newName });
            }
        });

        for (let i = arrayDates.length > 0 ? Number(arrayDates[0].name) : 8; i <= (arrayDates.length > 0 ? Number(arrayDates[arrayDates.length - 1].name) : 18); i++ ) {
            const hData = arrayDates.find(d => d.name === i.toString());
            const newr = {
                name: String(i).padStart(2, "0") + "h",
                short: String(i).padStart(2, "0") + "h"
            };
            newr[subsection] = hData ? hData.count : 0;
            result.push(newr);
        }

        const obj = {
            results: result,
            subsections: subsections
        };
        return obj;
    }
    dateUTCToLocal(dateString) {
        // Convert string to UTC date object
        const date = new Date(dateString + " UTC"); // exemple:Mon Jun 24 2024 11:59:12 GMT+0200

        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        // Get componants of UTC date
        const utcDay = date.getUTCDay();
        const utcDate = date.getUTCDate();
        const utcMonth = date.getUTCMonth();
        const utcYear = date.getUTCFullYear();
        const utcHours = date.getUTCHours();
        const utcMinutes = date.getUTCMinutes();
        const utcSeconds = date.getUTCSeconds();

        const UTCDateFormatted = `${days[utcDay]}, ${String(utcDate).padStart(2, "0")} ${months[utcMonth]} ${utcYear} ${String(utcHours).padStart(2, "0")}:${String(utcMinutes).padStart(2, "0")}:${String(utcSeconds).padStart(2, "0")} GMT`;

        // Convert string to date object
        const DateUTC = new Date(UTCDateFormatted);

        // Get componants of local date
        const year = DateUTC.getFullYear();
        const month = String(DateUTC.getMonth() + 1).padStart(2, "0");
        const day = String(DateUTC.getDate()).padStart(2, "0");
        const hours = String(DateUTC.getHours()).padStart(2, "0");
        const minutes = String(DateUTC.getMinutes()).padStart(2, "0");
        const seconds = String(DateUTC.getSeconds()).padStart(2, "0");

        // Format date to format "yyyy-MM-dd HH:mm:ss"
        const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

        return formattedDate;
    }

    getContinuousDatesArray(statecontinuouscallSessions) {
        if (!statecontinuouscallSessions) {return null;}
        // Clone statecontinuouscallSessions before modify
        const continuouscallSessions = JSON.parse(JSON.stringify(statecontinuouscallSessions));
        continuouscallSessions.forEach(cs => {
            cs.dateStart = this.dateUTCToLocal(cs.dateStart);
            cs.dateEnd = this.dateUTCToLocal(cs.dateEnd);
        });
        return continuouscallSessions;
    }

    getTreesArray(arrayTrees) {
        let result = [];
        arrayTrees.forEach(at => {
            let name = strings.NotSpecified;
            if (at.name && at.name !== "") {
                const split = at.name.split("#");
                name = split[split.length - 1];
            }
            result.push({ name: name, count: at.count });
        });
        result = result.sort((a, b) => a.count - b.count);
        return result;
    }
    getDurationText(secs) {
        const hour = Math.floor(secs / 3600);
        const min = Math.floor((secs - hour * 3600) / 60);
        const sec = Math.floor(secs - hour * 3600 - min * 60);
        if (hour > 0) {
            return hour + "h" + String(min).padStart(2, "0");
        }
        else {
            return min + "'" + String(sec).padStart(2, "0");
        }
    }
    getWaitingSum(list) {
        if (!list) {return 0;}
        let tot = 0;
        list.forEach(l => tot += l.count);
        return tot;
    }

    render() {
        return <>
            { this.state.results && this.state.results !== "noZone" ? <div className={classNames("verticalFlexContainer" )}
                style={{
                    flex: 1,
                    gap: "20px",
                    overflowY: "auto",
                    maxHeight: "calc(100% - 40px)"
                }}
            >
                <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                    <CardReporting
                        resultType="number"
                        flex={1}
                        textPill={"Total des appels".toUpperCase()}
                        resultReport={(this.state.results.countNominalcallSuccess
                                + this.state.results.countNominalcallFail
                                + this.state.results.countNominalcallUnavailable)}
                    />
                    <CardReporting
                        resultType="number"
                        flex={1}
                        textPill={"Appels Traités".toUpperCase()}
                        resultReport={(this.state.results.countNominalcallSuccess)}
                    />
                    <CardReporting
                        resultType="number"
                        flex={1}
                        textPill={"Appels Perdus".toUpperCase()}
                        resultReport={(this.state.results.countNominalcallFail)}
                    />
                </div>
                <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                    <CardReporting
                        resultType="number"
                        flex={1}
                        textPill={"Appels Hors Horaire".toUpperCase()}
                        resultReport={(this.state.results.countNominalcallUnavailable)}
                    />
                    <CardReporting
                        resultType="number"
                        flex={1}
                        textPill={strings.durationCallCardTitle.toUpperCase()}
                        resultReport={this.getDurationText(this.state.results.meanNominalcallDuration)}
                    />
                    <CardReporting
                        resultType="number"
                        flex={1}
                        textPill={strings.durationSumCallCardTitle.toUpperCase()}
                        resultReport={this.getDurationText(this.state.results.sumNominalcallDuration)}
                    />
                </div>
                <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                    <CardReporting
                        resultType="popularQueries"
                        flex={2}
                        textPill={strings.Categories.toUpperCase()}
                        resultReport={this.getTreesArray(this.state.results.callsCategories)}
                        textPill2={strings.Sujets.toUpperCase()}
                        resultReport2={this.getTreesArray(this.state.results.nominalcallQuestions)}
                    />
                    <CardReporting
                        resultType="notation"
                        minHeight="300px"
                        flex={2}
                        textPill={strings.satisfactionClient.toUpperCase()}
                        resultReport={this.getNotesArray(this.state.results.nominalcallReview, this.state.results.countNominalcallSuccess)}
                    />
                </div>
                <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                    <CardReporting
                        resultType="disponibilitylist"
                        flex={2}
                        minHeight="336px"
                        textPill={strings.DisponibilityClients.toUpperCase()}
                        resultReport={this.state.results.clientDisponibility}
                    />
                    {/* <CardReporting
                        resultType="disponibilitylist"
                        flex={2}
                        minHeight="336px"
                        textPill={strings.DisponibilityAgents.toUpperCase()}
                        resultReport={this.state.results.agentDisponibility}
                    /> */}
                </div>
                <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                    <CardReporting
                        resultType="graph"
                        flex={2}
                        textPill={strings.WaitingList.toUpperCase()}
                        resultReport={this.getDatesArray(this.state.results.waitingListDates, (mean) => {
                            const min = Math.floor(mean / 60);
                            const sec = mean - min * 60;
                            return " - Moy. " + min + "'" + String(sec).padStart(2, "0");
                        })}
                        textTooltip={strings.personsWaiting}
                        infosReportTopRight = {strings.TotalNumberOfPeopleWaiting + " : "
                                + (this.state.results.waitingListDates ? this.getWaitingSum(this.state.results.waitingListDates) : 0)
                        }
                    />
                    <CardReporting
                        resultType="graph"
                        flex={2}
                        textPill={strings.Jours.toUpperCase()}
                        textPill2={strings.Timings.toUpperCase()}
                        resultReport={this.getCallByDayOfWeekArray(this.state.results.nominalcallbyDayofweek)}
                        resultReport2={this.getCallByHourOfDayArray(this.state.results.nominalcallbyHourofday)}
                        infosReportTopRight = {strings.DistributionOf + " " + (this.state.results.countNominalcallSuccess + this.state.results.countNominalcallFail) + " " + strings.weekdayCalls}
                        infosReportTopRight2 = {strings.DistributionOf + " " + (this.state.results.countNominalcallSuccess + this.state.results.countNominalcallFail) + " " + strings.byTimeSlots}
                    />
                </div>
                <div>
                </div>
                <div className={classNames("verticalFlexContainer")} style={{
                    gap: "20px",
                    width: "calc(100% - 40px)",
                    alignItems: "center",
                    padding: "20px",
                    borderRadius: "6px",
                    background: "#D1D4DC"
                }}>
                    <div className={classNames("TextHeader32", "w700")}>
                        {strings.DisturbedSituations}
                    </div>
                    <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                        <CardReporting
                            resultType="number"
                            minHeight="310px"
                            flex={1}
                            textPill={strings.ContinuousModeTransitions.toUpperCase()}
                            resultReport={this.state.results.continuouscallSessions.length + "x"}
                            infosReport={strings.OverThePeriod}
                        />
                        <CardReporting
                            resultType="eventsdates"
                            flex={2}
                            textPill={strings.ListOfEvents.toUpperCase()}
                            resultReport={this.getContinuousDatesArray(this.state.results.continuouscallSessions)}
                        />
                        <CardReporting
                            resultType="notation"
                            minHeight="310px"
                            flex={1}
                            textPill={strings.satisfactionClient.toUpperCase()}
                            resultReport={this.getNotesArray(this.state.results.continuouscallReview, null)}
                        />
                    </div>
                </div>
            </div> : this.state.results ? <div> Aucun dashboard disponible. </div> : <div>
                <Loader dimensions="40px" color={"var(--primary-base)"} />
            </div>
            }
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(Dashboard);
